const app = {
    loadScript:function(src, callback) {
        // check if script already exists
        if (document.querySelector(`script[src="${src}"]`)) {
            console.log("Script already added:", src);
            callback();
            return;
        }

        // create and append script
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = function(){
            callback();
        }
        document.head.appendChild(script);
    },
    extractFontFamilies:(json) => {
        const fontFamilies = new Set();
        function traverse(obj) {
            if (!obj || typeof obj !== "object") return;

            // Check for font family properties
            if (obj.font_family && typeof obj.font_family === "string") {
                fontFamilies.add(obj.font_family);
            }
            if (obj.fontFamily && typeof obj.fontFamily === "string") {
                fontFamilies.add(obj.fontFamily);
            }

            // Check for ranges with font properties
            if (obj.ranges && Array.isArray(obj.ranges)) {
                obj.ranges.forEach((range) => {
                if (range.font_family && typeof range.font_family === "string") {
                    fontFamilies.add(range.font_family);
                }
                if (range.fontFamily && typeof range.fontFamily === "string") {
                    fontFamilies.add(range.fontFamily);
                }
                });
            }

            // Recursively traverse arrays and objects
            if (Array.isArray(obj)) {
                obj.forEach(traverse);
            } else {
                Object.values(obj).forEach((value) => {
                if (value && typeof value === "object") {
                    traverse(value);
                }
                });
            }
        }
        traverse(json);
        return fontFamilies;
    },
    getServerSideFontLinks:(json) => {
        if (!json) return null;

        const fontsToLoad = new Set();
        const jsonFonts = app.extractFontFamilies(json);

        jsonFonts.forEach((font) => {
            if (font !== "system" && !font.includes("monospace")) {
            fontsToLoad.add(font);
            }
        });

        if (fontsToLoad.size === 0) {
            return null;
        }

        // Generate Google Fonts URL (can combine multiple fonts)
        // Match client-side logic: replace hyphens with + and spaces with +
        const fontFamilies = Array.from(fontsToLoad).map((font) =>
            font.replace(/-/g, "+").replace(/\s+/g, "+")
        );
        const weights = "400;500;600;700";
        return `https://fonts.googleapis.com/css2?${fontFamilies
            .map((f) => `family=${f}:wght@${weights}`)
            .join("&")}&display=swap`;

  }
}

export default app;